<img alt="CareConnect Into.Care" src="assets/images/logo_CC-intocare_HOR.png" />

<article [innerHtml]="changelog | safeHtml"></article>

<button class="is-active" data-test="letsgo-button" (click)="closeItem.emit()">
	{{ "labels.actions.letsGo" | translate }}
</button>
